/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-timeline/content-control-studio-timeline.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  flex: 0 0 20.5%;
  background: #edeeef;
  width: 100%;
  display: flex;
  -webkit-user-select: none;
  user-select: none;
  padding-right: 13px;
}
:host > div {
  display: flex;
  flex-direction: column;
}
.left-col {
  flex: 0 0 18%;
}
.left-col .stats {
  height: 52px;
  max-height: 52px;
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  margin-bottom: 2px;
  align-self: stretch;
}
.left-col .stats .time {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.left-col .stats .time > div {
  display: flex;
  width: 100px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  height: 16px;
}
.left-col .stats .time > div label {
  flex: 0 0 30%;
}
.left-col .stats .time > div span {
  flex: 0 0 70%;
  font-weight: 600;
}
.left-col .tracks-labels {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 2px;
  width: 100%;
}
.left-col .tracks-labels > div {
  width: 100%;
  padding: 0px 0px 0px 12px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 14px;
  line-height: 30px;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  flex: 1;
  display: flex;
  align-items: center;
  max-height: 30px;
}
.right-col {
  flex: 0 0 82%;
  width: 1px;
  overflow: hidden;
  position: relative;
  display: flex;
}
.right-col .timeline {
  z-index: 2;
  margin-bottom: 2px;
  display: flex;
  min-width: 1px;
  height: 52px;
  max-height: 52px;
  font-size: 9px;
  overflow: hidden;
}
.right-col .timeline .timers {
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: -webkit-fill-available;
  font-size: 0.7rem;
  color: rgb(239, 93, 93);
  font-weight: 600;
}
.right-col .timeline .tooltip {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 0px 3px;
  line-height: 17px;
  border-radius: 3px;
  pointer-events: none;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 1000;
}
.right-col .timeline .segments {
  position: absolute;
  z-index: 2;
  display: flex;
  min-width: 1px;
  height: inherit;
}
.right-col .timeline .segments > * {
  display: flex;
  justify-content: flex-start;
  position: absolute;
}
.right-col .timeline .playhead {
  display: none;
  position: absolute;
  z-index: 100;
  height: 100%;
  flex-direction: column;
}
.right-col .timeline .playhead svg {
  fill: rgb(45, 187, 252);
}
.right-col .timeline .playhead svg.playhead-line {
  position: relative;
  left: 5px;
  bottom: 1px;
}
.right-col .timeline .scroll-zone {
  overflow: hidden;
  display: flex;
  position: relative;
  background: #e1e2e3;
  width: 100%;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper {
  position: relative;
  text-align: unset;
  display: flex;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block {
  display: flex;
  flex-direction: column;
  position: relative;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .time-label-container {
  position: absolute;
  top: 21px;
  left: -23px;
  width: 100%;
  text-align: left;
  z-index: 1;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .time-label {
  color: black;
  font-family: "OpenSans-Bold", sans-serif;
  line-height: 13px;
  font-size: 10px;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .block-svg {
  overflow: visible;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .block-svg line {
  stroke: #737e8c;
}
.right-col .tracks {
  z-index: 1;
  flex-grow: 1;
  background: #edeeef;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: space-around;
  min-width: 1px;
}
.right-col .tracks > div {
  background: #e1e2e3;
  display: flex;
  flex-direction: column;
  line-height: 20px;
  flex: 1;
  align-self: stretch;
  width: 100%;
  max-height: 30px;
  justify-content: space-between;
  position: relative;
}
.right-col .tracks > div > * {
  position: absolute;
  z-index: 2;
  height: 100%;
  width: fit-content;
}
.right-col .tracks > div > *.current-segment-shade {
  z-index: 1;
}
/*# sourceMappingURL=content-control-studio-timeline.component.css.map */
